var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRounded = function SvgArrowRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0A2.5 2.5 0 0115 2.5v19.074l5.505-5.365a2.501 2.501 0 013.49 3.582l-9.75 9.5a2.503 2.503 0 01-3.49 0l-9.75-9.5a2.5 2.5 0 113.49-3.582L10 21.574V2.5A2.5 2.5 0 0112.5 0z",
    fillRule: "evenodd"
  })));
};
export default SvgArrowRounded;